<template>
    <!--弹窗-->
    <el-dialog width="1200px" :title="title" :visible.sync="visible" :before-close="handleClose" top="5vh">
        <el-form ref="form" :inline="true" :model="query" class="query-form" size="mini">
            <el-form-item>
                <el-form-item label="店铺名：" class="query-form-item">
                    <el-input v-model="query.shop_name" placeholder="请输入店铺名" style="width: 200px;"></el-input>
                </el-form-item>
                <el-form-item label="国家：" class="query-form-item">
                    <el-select
                        v-model="query.state"
                        ref="carrerSelect"
                        style="width: 100px;"
                        size="mini"
                        filterable
                        @change="getList"
                        @clear="clearValue"
                        clearable
                    >
                        <el-option
                            v-for="item in us_arr"
                            :key="item.us"
                            clearable
                            :label="item.title"
                            :value="item.title"
                            :disabled="item.disabled">
                            <div class="keywords_arr_div">
                                <icon-svg :icon-class="item.us.toUpperCase()" style="font-size: 24px;margin-right:5px;"></icon-svg>
                                <span style="font-weight: 700; font-size: 14px;margin-left: 10px;">{{ item.title }}</span>
                            </div>
                        </el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="国家：" class="query-form-item">
                    <el-input v-model="query.state" placeholder="请输入国家" style="width: 200px;"></el-input>
                </el-form-item> -->
                <el-form-item>
                    <el-button icon="el-icon-refresh" @click="onReset"></el-button>
                    <el-button icon="el-icon-search" type="primary" @click="onSubmit">查询</el-button>
                </el-form-item>
            </el-form-item>
        </el-form>
        <el-table
            v-loading="loading"
            :data="list"
            size="mini"
            ref="multipleTable"
            class="table_content"
            :row-key="getRowKeys"
            :expand-row-keys="expands"
            @row-click="clickRowHandle"
            @expand-change="clickRowHandle1"
            border
            style="width: 100%;">
            <el-table-column type="expand">
                <template slot-scope="props">
                    <Child :ref="'inline' + props.row.id" :datasrow="props.row" @with-data="withData" :dataArr="withDataArr"></Child>
                </template>
            </el-table-column>
            <el-table-column
                label="店铺名"
                min-width="150"
                align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.shop_name }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="国家"
                width="120"
                align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.state }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="上传的文件名"
                min-width="150"
                align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.filename }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="状态"
                width="120"
                align="center">
                <template slot-scope="scope">
                    <el-tag type="success" v-if="scope.row.ad_min_name_tag == 1">已读取完成</el-tag>
                    <el-tag type="info" v-else>未读取完成</el-tag>
					
                </template>
            </el-table-column>
            <el-table-column
                label="开始日期"
                width="100"
                align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.start_date }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="结束日期"
                width="100"
                align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.end_date }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="创建时间"
                width="144"
                align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.add_time }}</div>
                </template>
            </el-table-column>
        </el-table>
        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose(false)"
            >取 消</el-button>
            <el-button style="float:right" size="mini" type="primary" @click="submitForm('formData')" :loading="loading">确定</el-button>
        </el-row>
    </el-dialog>
</template>
<script>
import * as api from "@/api/etyma/etyma";
import * as apis from "@/api/adv/adv";
import Child from "./child";
export default {
    components: { Child },
    data() {
        return {
            expands: [],
            list: [],
            query: {
                page: 1,
                shop_name: "",
                state: "",
                limit: 9999
            },
            us_arr: [
                {
                    us: "us",
                    title: "美国"
                },
                {
                    us: "uk",
                    title: "英国"
                },
                {
                    us: "de",
                    title: "德国"
                }
            ],
            withDataArr: [],
            loading: false
        };
    },
    props: {
        formData: {
            type: Object,
            default: () => {}
        },
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        }
    },
    methods: {
        clearValue() {
            this.query.state = "";
        },
        onArr(arr) {
            this.withDataArr = arr;
        },
        // 获取row的key值
        getRowKeys(row) {
            return row.id;
        },
        withData(id) {
            if (this.withDataArr.indexOf(id) > -1) {
                this.withDataArr.splice(this.withDataArr.indexOf(id), 1);
            } else {
                this.withDataArr.push(id);
            }
        },
        //查询
        onSubmit() {
            this.query.page = 1;
            this.getList();
        },
        //重置
        onReset() {
            this.query = {
                page: 1,
                shop_name: "",
                state: "",
                limit: 9999
            };
            this.date = [];
            this.getList();
        },
        onList() {
            if (this.list.length != 0) {
                return;
            }
            this.getList();
        },
        getList() {
            this.loading = true;
            apis.show_list(this.query)
                .then(res => {
                    this.loading = false;
                    if (res.code === 0) {
                        this.list = res.data.detail_list;
                        this.query.total = res.data.total;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        //点击展开
        clickRowHandle(row) {
            if (row.ad_min_name_tag == 0) {
                return this.$message({
                    type: "info",
                    message:
                        "数据尚未读取完成，请等待完成后再点击获取列表数据！"
                });
            }
            if (this.expands.includes(row.id)) {
                this.expands = this.expands.filter(val => val !== row.id);
            } else {
                this.expands.push(row.id);
                let str = "inline" + row.id;
                let that = this;
                setTimeout(function() {
                    that.$refs[str].getList();
                }, 10);
            }
        },
        clickRowHandle1(row) {
            if (row.ad_min_name_tag == 0) {
                return this.$message({
                    type: "info",
                    message:
                        "数据尚未读取完成，请等待完成后再点击获取列表数据！"
                });
            }
            if (this.expands.includes(row.id)) {
                this.expands = this.expands.filter(val => val !== row.id);
            } else {
                this.expands.push(row.id);
                let str = "inline" + row.id;
                let that = this;
                setTimeout(function() {
                    that.$refs[str].getList();
                }, 10);
            }
        },
        // 保存信息
        submitForm() {
            if (this.withDataArr.length == 0) {
                return this.$message({
                    type: "error",
                    message: "请勾选需要更改的数据!"
                });
            }
            let obj = {
                record_id: this.formData.id,
                parent_asin: this.formData.parent_asin,
                state: this.formData.state,
                remark: this.withDataArr.toString()
            };
            this.loading = true;
            api.update_relevance_detail(obj)
                .then(res => {
                    this.loading = false;
                    if (res.code === 0) {
                        this.$message({
                            type: "success",
                            message: "修改成功！"
                        });
                        this.$bus.$emit(
                            "busState" + this.formData.id,
                            res.progress_key,
                            "disabledRelevance",
                            "auto_str_Relevance",
                            "autotype_Relevance",
                            "修改关联关系"
                        );
                        this.handleClose(true);
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                    this.$message({
                        type: "error",
                        message: "网络出现问题，请查看数据是否添加完成！"
                    });
                });
        },
        // 关闭弹窗
        handleClose(isshow) {
            this.loading = false;
            this.expands = [];
            this.withDataArr = [];
            this.$emit("close-callback", isshow);
        }
    }
};
</script>
<style type="text/scss" lang="scss" scoped>
.download {
    display: flex;
    justify-content: center;
}
</style>
